/*
 * mapNavProps
 */

import get from 'lodash/get';
import omitBy from 'lodash/omitBy';
import isEmpty from 'lodash/isEmpty';
import getUrlByUid from 'src/common/utils/get-url-by-uid.js';
import { mapPrismicProp } from '../components/ReactFromPrismic';

const removeEmpty = obj => omitBy(obj, isEmpty);

/** Check the link is valid */
const isLinkValid = link =>
  link &&
  Object.keys(link).length > 0 &&
  (link.id || link.main) &&
  link.type !== 'dynamic_layout';

/**
 * Map the list prop type for the nav
 * @function
 * @param {object} prop The property value to map
 * @param {object} country The country model.
 * @param {string} type Type of the property, i.e. 'list'
 * @returns {object|undefined} Property mapped to ReactFromJSON friendly shape
 */
export default (prop, country, type) => {
  if (type === 'nav_list' && prop.items.length > 0) {
    return {
      children: prop.items.map(item => {
        const url = getUrlByUid(item.link.uid, { country });
        return mapPrismicProp({
          ...item,
          title: item.title || get(item, 'link.title'),
          children: isLinkValid(item.link) ? item.link : null,
          _type: 'nav_item',
          href:
            item.link.type === 'dynamic_layout'
              ? url
              : ''
        });
      })
    };
  } else if (type === 'nav') {
    return {
      fullWidth: get(prop, 'body[0].sliceType') === 'expanded_nav_list'
    };
  } else if (type === 'expanded_nav_list' && prop.items.length > 0) {
    return {
      children: prop.items.map(({ link, ...item }) => {
        const tidyItem = removeEmpty(item);

        const linkParams = {};

        if (get(link, 'main.documentType') === 'product') {
          linkParams.href = link.productListing.href;
          linkParams.image = link.productInformation.image;
          linkParams.imageBackground = link.productInformation.backgroundColor;
          linkParams.imageSize = 'contain';
          linkParams.imageFullWidth = false; // We never go full width on product images, because they're inconsistently padded
        }

        const url = getUrlByUid(link.uid || link.main.uid, {
          country
        });

        return mapPrismicProp({
          imageFullWidth: true, // Safe to go full width here, because content author can tweak image padding
          imageSize: 'cover',
          ...linkParams,
          ...tidyItem,
          _type: 'expanded_nav_item',
          href: url,
        });
      })
    };
  }
};
